<template>
  <div class="home" v-on:scroll="onScroll" :class="[opennav ? 'open': '', !scrolled ? '-scrolled': '']">
    <Nav :scrollcount.sync="scrollval" v-on:childToParent="onChildClick"></Nav>

    <div class="sticky" :class="!$googleplay && !$appstore ? '': ''">
      <a :href="$appstore" :class="!$appstore ? 'sticky__disabled': ''">
        <img src="/img/icon-appstore.png" alt="icon fb">
      </a>
      <a :href="$googleplay" :class="!$googleplay ? 'sticky__disabled': ''">
        <img src="/img/icon-googleplay.png" alt="icon fb">
      </a>
    </div>
    <div class="header" :style="belowStyles" :class="opennav ? 'open': ''">
      <div class="header__bg" :class="opennav ? 'open': ''">
        <p class="header__title txt--purple" >Healthcare<br>reimagined</p>
        <Download :divclass="['download__header']"></Download>
      </div>
    </div>
    <!-- <div class="scroll" v-if="scrolled" v-show="!opennav">
      <a href="#about">
        <span>Scroll to Discover</span>
        <img src="/img/arrow-down.png" alt="arrow down">
      </a>
    </div> -->
    <div class="about" id="about" :class="opennav ? 'open': ''">
      <div class="about__bg"></div>
      <div class="about__desc">
        <p class="about__title txt--purple">Get the healthcare you need, your way</p>
        <p class="about__txt">Healthcare now made simple and easy. <strong>HealthNow</strong> is your all-in-one health app for your primary care needs.</p>
        <p class="about__faq">Still got questions?  <a href="/frequently-asked-questions">Get your answers here</a></p>
      </div>
    </div>
    <div class="bg-purple" :class="opennav ? 'open': ''">
      <div class="body body__margin">
        <!-- <Point></Point>
        <Offer></Offer> -->
        <Feature></Feature>
        <Partner></Partner>
        <Download :divclass="['download__fitborder']"></Download>
        <Mission></Mission>
      </div>
      <!-- <Doctor></Doctor> -->
      <Establishment></Establishment>
      <div class="footer__div">
        <FooterHome></FooterHome>
      </div>
    </div>
  </div>
</template>

<script>
import Nav from '../components/Nav.vue';
import Feature from '../components/Feature.vue';
import Partner from '../components/Partner.vue';
import Download from '../components/Download.vue';
// import Doctor from '../components/Doctor.vue';
import Establishment from '../components/Establishment.vue';
import Mission from '../components/Mission.vue';
import FooterHome from '../components/FooterHome.vue';

export default {
  name: 'Home',
  data() {
    return {
      scrolled: true,
      scrollval: 0,
      opennav: false,
    };
  },
  components: {
    Nav,
    Feature,
    Partner,
    Download,
    // Doctor,
    Establishment,
    Mission,
    FooterHome,
  },
  computed: {
    belowStyles() {
      const val = 1; // (1 - this.scrollval / 530);
      return {
        opacity: `${val}`,
      };
    },
  },
  mounted() {
    // const browser = navigator.userAgent.toLowerCase();
    // if (browser.indexOf('firefox') > -1) {
    //   document.getElementsByClassName('maindiv')[0].className = 'maindiv firefox';
    // } else if (navigator.userAgent.match(/(iPad|iPhone|iPod)/g)) {
    //   document.getElementsByClassName('maindiv')[0].className = 'maindiv ios';
    // }
    // window.addEventListener('scroll', (e) => {
    //   this.scrollval = window.scrollY;
    //   this.scrolled = true;
    //   if (this.scrollval !== 0) {
    //     this.scrolled = false;
    //   }
    // });

    const body = document.getElementsByTagName('body')[0];
    body.classList.add('home');
  },
  methods: {
    onChildClick(value) {
      this.opennav = value;
    },
    onScroll() {
      const el = document.querySelector('div.home');
      // const elheader = document.querySelector('.header');
      this.scrollval = el.scrollTop;

      this.scrolled = true;
      if (el.scrollTop !== 0) {
        this.scrolled = false;
      }
    },
  },
};
</script>
